module.exports = __webpack_public_path__ + "img/pizza_meat.d8b01bae.png";